import { render } from "./ReopenTicket.vue?vue&type=template&id=4aff7869&scoped=true"
import script from "./ReopenTicket.vue?vue&type=script&lang=js"
export * from "./ReopenTicket.vue?vue&type=script&lang=js"

import "./ReopenTicket.vue?vue&type=style&index=0&id=4aff7869&scoped=true&lang=css"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aff7869"]])

export default __exports__